import type { ValidationRuleWithParams } from '@vuelidate/core'
import {
  // GlobalModal,
  // ModalBase,
  // PushButton,
  Step,
  TheAccordion,
  TheBreadcrumb,
  TheBreadcrumbs,
  TheButton,
  TheFooter,
  TheInput,
  TheLogin,
  TheModal,
  TheNavigation,
  TheOutput,
  TheSidebar,
  TheSidebarLink,
  TheTable,
} from '~/components/index'

import '@unocss/reset/tailwind.css'
import 'uno.css'
import '~/styles/main.css'

// # Validation
const requiredWithMessage: (msg: string) => ValidationRuleWithParams<object, any> = requiredWith
const emailWithMessage: (msg: string) => ValidationRuleWithParams<object, any> = emailWith
const requiredUnlessWithMessage: (msg: string, asyncFunction: () => boolean) => ValidationRuleWithParams<object, any> = requiredUnlessWith

// # Functions
const isDateAfterWithMessage = isDateAfter
const isDateAfterStringWithMessage = isDateAfterString

// # Modal
const useModal = {
  handleInfo: modal.handleInfo,
  handleWarning: modal.handleWarning,
  handleConfirm: modal.handleConfirm,
  handleError: modal.handleError,
}

// # Filter
const useFilter = {
  formatDatetime: filter.formatDatetime,
  formatDate: filter.formatDate,
}

// # Utils
const useUtils = {
  cloneDeep: clone
}

export default {
  install: (app: any, options?: any) => {

    // Router
    const { router } = options
    app.provide('default-router', router)

    // app.config.globalProperties.$sberg = {}

    // Components
    // app.component('GlobalModal', GlobalModal),
    // app.component('ModalBase', ModalBase),
    // app.component('PushButton', PushButton),
    app.component('Step', Step)
    app.component('TheAccordion', TheAccordion)
    app.component('TheBreadcrumb', TheBreadcrumb)
    app.component('TheBreadcrumbs', TheBreadcrumbs)
    app.component('TheButton', TheButton)
    app.component('TheFooter', TheFooter)
    app.component('TheInput', TheInput)
    app.component('TheLogin', TheLogin)
    app.component('TheModal', TheModal)
    app.component('TheNavigation', TheNavigation)
    app.component('TheOutput', TheOutput)
    app.component('TheSidebar', TheSidebar)
    app.component('TheSidebarLink', TheSidebarLink)
    app.component('TheTable', TheTable)
  },
}

export * from './resolver'
export {
  // GlobalModal,
  // ModalBase,
  // PushButton,
  Step,
  TheAccordion,
  TheBreadcrumb,
  TheBreadcrumbs,
  TheButton,
  TheFooter,
  TheInput,
  TheLogin,
  TheModal,
  TheNavigation,
  TheOutput,
  TheSidebar,
  TheSidebarLink,
  TheTable,
  requiredWithMessage,
  emailWithMessage,
  requiredUnlessWithMessage,
  isDateAfterWithMessage,
  isDateAfterStringWithMessage,
  useModal,
  useFilter,
  useUtils,
}
